import { css } from '@emotion/core';
import { Icon, List } from 'antd';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';

import Button from '@/src/shared/components/Button';
import { bp, colors } from '@/styles';

import SearchBar from './SearchBar';

const styles = {
  searchBar: css`
    margin-bottom: 24px;
    @media ${bp.sm} {
      margin-right: 75px;
      line-height: 36px;
    }
    @media ${bp.md} {
      margin-bottom: -16px;
    }
    @media ${bp.xl} {
      font-size: 36px;
      line-height: 48px;
    }
  `,
  searchInput: css`
    display: flex;
    align-itmes: center;
  `,
  list: css`
    background-color: ${colors.white};
    position: absolute;
    z-index: 100;
    left: 5px;
    width: 320px;
    max-height: 193px;
    overflow: auto;
    border-radius: 4px;
    // margin-bottom: 10xp;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
    @media ${bp.sm} {
      left: 15px;
    }
    @media ${bp.sm} {
      width: 375px;
      left: auto;
      right: 25px;
    }
    @media ${bp.md} {
      width: 400px;
      right: auto;
    }
  `,
  listItemHeadCom: css`
    height: 32px;
    padding-left: 16px;
    font-family: Lato;
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0;
    border-bottom: 0px !important;
    line-height: 16px;
    display: flex;
    justify-content: space-between;
    color: ${colors.secondaryGrayDark};
  `,
  topLevelCommitteeLink: css`
    padding-left: 0px;
    padding-right: 16px;
    color: ${colors.secondaryBlue};
    font-weight: 400;
    font-size: 12px;
  `,
  listItem: css`
    height: 32px;
    padding-left: 24px;
    padding-right: 16px;
    border-bottom: 0px !important;
    &:hover {
      background-color: ${colors.accentBlueLight};
    }
  `,
  listItemText: css`
    font-family: Lato;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 20px;
    color: ${colors.secondaryBlue};
    width: 100%;
    display: flex;
    justify-content: space-between;
  `,
  committeeName: css`
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
};

const CommitteeSearch = ({ committees }) => {
  const [searchInput, setSearchInput] = useState('');
  const [filteredCommittees, setFilteredCommittees] = useState([]);

  useEffect(() => {
    const filtered = committees.reduce((r, { Committee, CommitteeCode, subCommittees }) => {
      // eslint-disable-next-line
      const subComms = subCommittees.filter(({ Committee, CommitteeCode }) => {
        return (
          Committee.toLocaleLowerCase().includes(searchInput.toLocaleLowerCase()) ||
          CommitteeCode.toString().includes(searchInput)
        );
      });
      if (subComms && subComms.length) {
        r.push({ Committee, CommitteeCode, subCommittees: [...subComms] });
      }
      return r;
    }, []);
    setFilteredCommittees(filtered);
  }, [searchInput]);

  const returnSearch = value => {
    setSearchInput(value);
  };

  return (
    <div css={styles.searchBar}>
      <div css={styles.searchInput}>
        <SearchBar returnSearchTerm={returnSearch} />
        <Button size="small">Search</Button>
      </div>
      {filteredCommittees.length > 0 && searchInput.length > 0 ? (
        <List
          css={[styles.list]}
          dataSource={filteredCommittees}
          renderItem={item => (
            <>
              <List.Item css={styles.listItemHeadCom}>
                <div>
                  {item.Committee} ({item.subCommittees.length}{' '}
                  {item.subCommittees.length === 1 ? 'Result' : 'Results'})
                </div>
                <div css={styles.topLevelCommitteeLink}>
                  <Link
                    href="/policy/committees/[slug]"
                    as={`/policy/committees/${item.CommitteeCode}`}
                  >
                    <a>
                      <Icon type="eye" theme="filled" /> View
                    </a>
                  </Link>
                </div>
              </List.Item>
              {item.subCommittees.length > 0 ? (
                <List
                  dataSource={item.subCommittees} // .filter(sub => sub.Committee.toLocaleLowerCase().includes(searchInput.toLocaleLowerCase()))
                  renderItem={sub => (
                    <List.Item css={styles.listItem}>
                      <div css={styles.listItemText}>
                        <div css={styles.committeeName}>{sub.Committee}</div>
                        <div>
                          <Link
                            href="/policy/committees/[slug]"
                            as={`/policy/committees/${sub.CommitteeCode}`}
                          >
                            <a>
                              <Icon type="eye" theme="filled" /> View
                            </a>
                          </Link>
                        </div>
                      </div>
                    </List.Item>
                  )}
                />
              ) : null}
            </>
          )}
        />
      ) : null}
    </div>
  );
};

export default CommitteeSearch;
